<template>
  <div v-show="ready" class="curation-block">
    <div class="section-header">
      <div class="curation-title">{{ title }}</div>
    </div>
    <div class="section-content">
      <div v-for="(product, key) in products" :key="key" class="item">
        <product-block
          v-bind="{ info: product, modifier: 's', gaEvent: '007' }"
        />
      </div>
    </div>
    <router-link
      :to="{
        name: 'curation',
        params: { id: curationGuid },
        query: {},
      }"
      class="touch-area no-blue-highlight"
    >
      <v-btn
        @click="ga"
        color="primary"
        block
        rounded
        outlined
        class="more-link"
      >
        更多商品
      </v-btn>
    </router-link>
  </div>
</template>

<script>
import ProductBlock from '@/components/ProductBlock'
export default {
  name: 'curationC',
  components: {
    ProductBlock,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    curationGuid: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ready() {
      // return this.theData != null && this.theData.products != null && this.theData.products.length >= 6;
      return true
    },
  },
  data: function() {
    return {}
  },
  methods: {
    ga() {
      gtag('event', 'click', {
        event_id: '008',
        location: '首頁',
        event_category: '策展--更多',
        event_label: this.curationGuid,
        value: 8,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.curation-block {
  padding: 24px 4.3%;
  overflow-x: hidden;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
}

.section-header {
  .curation-title {
    font-size: 18px;
    font-weight: bold;
    color: #383838;
    text-align: center;
    padding-bottom: 10px;
  }
}
.more-link {
  margin-top: 10px;
}

.section-content {
  display: flex;
  flex-wrap: wrap;
  .item {
    padding: 0;
    width: 32%;
    max-width: 32%;
    margin-bottom: 10px;
    &:nth-child(2),
    &:nth-child(5) {
      margin: 0 2%;
    }
    img {
      width: 100%;
    }
  }
}

.touch-area {
  span {
    margin-right: 4px;
  }
}
</style>
